// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__G3b3W"};